module.exports = __webpack_public_path__ + "images/icon-arrow-left-white_58b1e3e53845d4870ac2165a2bc56bd9.svg";